// src/comps/AboutUs.jsx

import React from "react";
import { Navbar } from "../App";
import batch22Logo from "../assets/batch22_logo.png";

const AboutUs = () => {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <section className="container mx-auto py-16 px-4 flex-grow">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12">
          {/* Logo Section */}
          <div className="flex justify-center">
            <img
              src={batch22Logo}
              alt="Batch-88 Foundation Logo"
              className="h-80 w-auto rounded-xl"
            />
          </div>

          {/* Text Section */}
          <div className="space-y-6">
            <h1 className="text-black text-5xl font-bold">
              About Spreeha Batch-88 Foundation
            </h1>
            <p className="text-black text-lg leading-relaxed">
              Spreeha BUET 88 Foundation is a non-profit originally registered
              as BUET 88 Welfare Foundation with the Social Welfare Department
              in Bangladesh. It is run by alumni of the 1988-89 session at
              BUET, Dhaka.
            </p>
            <p className="text-black text-lg leading-relaxed">
              Founded in 2012 by dedicated batch members, our goal is to
              contribute to social welfare and charitable activities in
              Bangladesh. In 2021, we launched a global initiative to engage
              BUET alumni worldwide, strengthening our network and amplifying
              humanitarian efforts.
            </p>
            <p className="text-black text-lg leading-relaxed">
              All charitable activities are overseen by our Global Executive
              Committee (GEC), whose members span the USA, Canada, Europe,
              Australia, and Bangladesh. Each region organizes events and
              outreach in collaboration with partner organizations.
            </p>
            <p className="text-black text-lg leading-relaxed">
              We’ve partnered with Ankur International, Sonjog Foundation, and
              others to serve communities at home and abroad—always driven by
              our alumni’s passion for giving back.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
